module.exports = __webpack_public_path__ + "img/bingo_ball-14.b1a0139a.png";